<template>
  <div>
    <Message
      :time="this.time"
      :message="this.message"
      :userName="this.userName"
      messageHeader="Quick Poll"
    >
      <IconBase
        slot="icon"
        :height="24"
        :width="24"
        :view-box="`0 0 32 32`"
        :fill="'#50C6DF'"
      >
        <IconPoll />
      </IconBase>
    </Message>
    <div class="poll-actions">
      <el-button
        class="thumbs-up"
        @click="updateThumbsUpThumbsDown('thumbsUp')"
        type="text"
      >
        <IconBase
          :height="24"
          :width="24"
          :view-box="`0 0 24 24`"
          :fill="prevAction == 'thumbsUp' ? '#50C6DF' : '#BFBFC5'"
        >
          <IconThumbsUpFilled v-if="prevAction === 'thumbsUp'" />
          <IconThumbsUpOutlined v-else />
        </IconBase>
        <div class="poll-count">
          <span>{{ this.thumbsUpCount }}</span>
        </div>
      </el-button>
      <el-button
        class="thumbs-down"
        @click="updateThumbsUpThumbsDown('thumbsDown')"
        type="text"
      >
        <IconBase
          :height="24"
          :width="24"
          :view-box="`0 0 24 24`"
          :fill="prevAction === 'thumbsDown' ? '#50C6DF' : '#BFBFC5'"
        >
          <IconThumbsDownFilled v-if="prevAction === 'thumbsDown'" />
          <IconThumbsDownOutlined v-else />
        </IconBase>
        <div class="poll-count">
          <span>{{ this.thumbsDownCount }}</span>
        </div>
      </el-button>
    </div>
  </div>
</template>

<script>
import Message from "./Message";
import IconBase from "../IconBase";
import IconPoll from "../icons/IconPoll";
import IconThumbsUpOutlined from "../icons/IconThumbsUpOutlined";
import IconThumbsDownOutlined from "../icons/IconThumbsDownOutlined";
import IconThumbsUpFilled from "../icons/IconThumbsUpFilled";
import IconThumbsDownFilled from "../icons/IconThumbsDownFilled";
import { getSocketPayload } from "../../utils";

export default {
  name: "Poll",
  components: {
    Message,
    IconBase,
    IconPoll,
    IconThumbsUpOutlined,
    IconThumbsDownOutlined,
    IconThumbsUpFilled,
    IconThumbsDownFilled
  },
  props: ["pollId", "socket", "time", "message", "userName"],
  mounted: function() {
    this.initSocket();
  },
  data: function() {
    return {
      thumbsUpCount: 0,
      thumbsDownCount: 0,
      prevAction: ""
    };
  },
  methods: {
    initSocket() {
      this.socket.on(this.pollId, data => {
        this.thumbsUpCount = data.thumbsUpCount;
        this.thumbsDownCount = data.thumbsDownCount;
      });
    },
    updateThumbsUpThumbsDown(action) {
      let actionData = {
        thumbsUp: 0,
        thumbsDown: 0
      };

      if (this.prevAction === "") {
        actionData =
          action === "thumbsUp"
            ? {
                thumbsUp: 1,
                thumbsDown: 0
              }
            : {
                thumbsUp: 0,
                thumbsDown: 1
              };
        this.prevAction = action;
      } else if (this.prevAction === action) {
        actionData =
          action === "thumbsUp"
            ? {
                thumbsUp: -1,
                thumbsDown: 0
              }
            : {
                thumbsUp: 0,
                thumbsDown: -1
              };
        this.prevAction = "";
      } else {
        actionData =
          action === "thumbsUp" && this.prevAction === "thumbsDown"
            ? {
                thumbsUp: 1,
                thumbsDown: -1
              }
            : {
                thumbsUp: -1,
                thumbsDown: 1
              };
        this.prevAction = action;
      }
      this.socket.emit(
        "UPDATE_POLL_COUNT",
        getSocketPayload({
          action: actionData,
          pollId: this.pollId
        })
      );
    }
  }
};
</script>

<style scoped>
.poll-header {
  font-weight: bold;
  color: black;
  font-size: 15px;
  margin-bottom: 5px;
}

.poll-count {
  position: relative;
  top: -2px;
  font-weight: bold;
  font-size: 22px;
  display: inline;
  font-weight: normal;
  font-size: 20px;
  line-height: 25px;
  color: #e7e6fa;
  margin-left: 12px;
}

.poll-message {
  color: black;
  font-size: 15px;
  word-break: break-all;
}

.time {
  right: 60px;
  position: absolute;
  margin-top: -27px;
}

.userName {
  font-style: italic;
  font-size: 15px;
  color: black;
  font-weight: bold;
}

.poll-actions {
  padding-top: 11px;
  padding-left: 43px;
}

.thumbs-down {
  margin-left: 43px;
}
</style>
